import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import {
  faPlay,
  faAngleDoubleLeft,
  faHome,
} from '@fortawesome/free-solid-svg-icons'
import Fbapi from 'vue-fbapi'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

library.add(faFacebookF, faTwitter, faInstagram, faPlay, faWhatsapp, faAngleDoubleLeft, faHome)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Fbapi, {
  appId: '1149272818562361', //TODO publicar app
  autoLogAppEvents: true,
  xfbml: true,
  version: 'v3.1'
})

Vue.use(VueAnalytics, {
  // id: 'UA-27744179-21',//paula
  id: 'UA-80728886-38', //especiales
  router
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
